
import React from 'react';
import { Button } from "@/components/ui/button";

interface DebugControlPanelProps {
  currentOffset: number | null;
  adjustOffset: (adjustment: number) => void;
  resetOffset: () => void;
}

/**
 * Control panel for adjusting touch offset in debug mode
 */
export const DebugControlPanel: React.FC<DebugControlPanelProps> = ({ 
  currentOffset, 
  adjustOffset, 
  resetOffset 
}) => {
  return (
    <div
      className="offset-control-panel"
      style={{
        position: 'fixed',
        bottom: '60px',
        right: '10px',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
        padding: '8px',
        borderRadius: '4px',
        fontSize: '12px',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
      }}
    >
      <div style={{ marginBottom: '4px', fontWeight: 'bold' }}>
        Current Offset: {currentOffset !== null ? `${currentOffset}px` : 'Detecting...'}
      </div>
      <div style={{ display: 'flex', gap: '4px' }}>
        <Button size="xs" onClick={() => adjustOffset(-5)}>-5px</Button>
        <Button size="xs" onClick={() => adjustOffset(-1)}>-1px</Button>
        <Button size="xs" onClick={() => adjustOffset(1)}>+1px</Button>
        <Button size="xs" onClick={() => adjustOffset(5)}>+5px</Button>
      </div>
      <Button 
        size="xs" 
        variant="outline"
        onClick={resetOffset}
      >
        Reset Offset
      </Button>
    </div>
  );
};
